interface Edge<TNode> {
  node: TNode
}

export type Edges<TNode> = Edge<TNode>[]

export function edgesToCollection<TNode>(edges: Edges<TNode>): TNode[] {
  return edges.map(({ node }) => node)
}
